module.exports = __webpack_public_path__ + "fonts/source-sans-pro-v13-latin-300italic.a00b3aa7.ttf";